<script setup lang="ts">
import { useFieldArray } from 'vee-validate'
import { inject, onMounted, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import { ZoppmPodpisovatelResponse } from '/@src/client-portal'
import * as apis from '/@src/client-portal/api'
import { formatDateString } from '/@src/utils/format'

const specResponse = inject('specResponse')
const { t } = useI18n()
const api = new apis.ZoppmDraftApi()
const isReadOnly = inject<boolean>('isReadOnly')

const podpisovatel = reactive<ZoppmPodpisovatelResponse>({})
const { push, remove } = useFieldArray('podpisovatelia')

onMounted(async () => {
  if (!isReadOnly) {
    const { data } = await api.getDefaultPodpisovateliaListZoppmDraft()
    Object.assign(podpisovatel, data?.content?.[0] || {})

    remove(0)
    push(podpisovatel)
  }
})
</script>

<template>
  <div class="content-wrapper">
    <IDSKParagraph v-if="!isReadOnly" class="personal-data">
      <IDSKHeading as="h3" variant="s" class="no-margin">{{
        podpisovatel.menoUplne
      }}</IDSKHeading>

      <Address :data="podpisovatel.adresaUplna" /> <br />
      <Address :data="podpisovatel.stat" />
      <span v-if="podpisovatel.datumNarodenia">
        {{
          `${t('personal.birth')}: ${formatDateString(podpisovatel.datumNarodenia) || ''}`
        }}</span
      >
    </IDSKParagraph>
  </div>
</template>

<style lang="scss" scoped>
div.content-wrapper {
  /*max-width: 650px;*/
  box-sizing: border-box;
}
p.personal-data {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 0 30px;
}
.no-margin {
  margin: 0;
}
</style>

<i18n lang="yaml">
sk:
  title:
    signature: 'Podpis žiadateľa'
  info1: 'Dokumenty je možné podpísať až po záväznom zaevidovaní žiadosti do ISPO a stiahnutí vygenerovaného súboru (.pdf).'
  info2: 'Pokiaľ žiadateľa zastupujete na základe poverenia v tomto úkone, je potrebné, aby ste k žiadosti o pridelenie prostriedkov mechanizmu priložili splnomocnenie (pozn. na formulári žiadosti zostávajú identifikačné údaje žiadateľa).'
  personal:
    birth: 'Dátum narodenia'

en:
  title:
    signature: 'Signature'
  info1: 'Dokumenty je možné podpísať až po záväznom zaevidovaní žiadosti do ISPO a stiahnutí vygenerovaného súboru (.pdf).'
  info2: 'Pokiaľ žiadateľa zastupujete na základe poverenia v tomto úkone, je potrebné, aby ste k žiadosti o pridelenie prostriedkov mechanizmu priložili splnomocnenie (pozn. na formulári žiadosti zostávajú identifikačné údaje žiadateľa).'
  personal:
    birth: 'Date of birth'
</i18n>
